var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71127 0.216628L7.70675 4.49416C7.79889 4.55734 7.87271 4.63512 7.92328 4.72231C7.97384 4.8095 8 4.9041 8 4.99981C8.00001 5.09551 7.97385 5.19012 7.92329 5.27732C7.87272 5.36452 7.7989 5.44231 7.70675 5.50549L1.71127 9.78303C1.42858 9.99184 1.01654 10.0564 0.652617 9.94845C0.288696 9.84053 0.0345679 9.58006 -3.15875e-08 9.27736L-4.05389e-07 0.725789C0.0330872 0.421923 0.285692 0.160314 0.651136 0.052371C1.01655 -0.0567379 1.42705 0.00778097 1.71127 0.216628Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTriangle);
export default __webpack_public_path__ + "static/media/right-triangle.adc86cb9d91b8043565e8c942d39b377.svg";
export { ForwardRef as ReactComponent };